import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody, ResponseBody } from '@/shared/api/generated';

type AggregateIssuesPath = '/v1/workspaces/{workspace_id}/issues/aggregate';

type AggregateIssuesParams = Partial<PathParams<AggregateIssuesPath, 'post'>> &
  RequestBody<AggregateIssuesPath, 'post'>;
type AggregateIssuesResponse = ResponseBody<AggregateIssuesPath, 'post'>;
type AggregateIssuesFunction = (
  params: AggregateIssuesParams,
) => Promise<AggregateIssuesResponse>;

/**
 * 이슈 집계 (기간별)
 */
export const aggregateIssues: AggregateIssuesFunction = ({
  workspace_id,
  filter_set,
  period,
  issue,
}) =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/issues/aggregate`, {
      filter_set,
      period,
      issue,
    })
    .then((res) => res.data);
